export default __webpack_public_path__ + "static/media/YouthImage3.068af146.png";